<template>
	<div class="l-edit-dialog-box" style="max-height: 75vh; height: 75vh">
		<!--信息展示-->
		<table class="l-info-table" style="margin-top: -10px">
			<tbody>
				<tr>
					<td>
						<span class="l-info-label">单号：</span>
						<span class="l-info-content">{{ form_data.order_no }}</span>
					</td>
					<td>
						<span class="l-info-label">处置类型：</span>
						<span class="l-info-content">{{ getTypeName(form_data.type) }}</span>
					</td>
					<td>
						<span class="l-info-label">处置日期：</span>
						<span class="l-info-content">{{ form_data.dispose_date }}</span>
					</td>
				</tr>
				<tr>
					<td>
						<span class="l-info-label">资产数量：</span>
						<span class="l-info-content">{{ form_data.assets_count }}</span>
					</td>
					<td>
						<span class="l-info-label">处置金额：</span>
						<span class="l-info-content">{{ form_data.money }} 元</span>
					</td>
					<td>
						<span class="l-info-label">审批状态：</span>
						<span class="l-info-content"><l-approval-state :state="form_data.state"></l-approval-state></span>
					</td>
				</tr>
				<tr>
					<td>
						<span class="l-info-label">申请人：</span>
						<span class="l-info-content">{{ form_data.create_user_name }}</span>
					</td>
					<td>
						<span class="l-info-label">申请时间：</span>
						<span class="l-info-content">{{ form_data.create_time }}</span>
					</td>
				</tr>
				<tr v-show="file_list.length > 0">
					<td colspan="3">
						<span class="l-info-label">附件：</span>
						<div style="display: inline-block; vertical-align: top">
							<div v-for="item in file_list" :key="item.url">
								{{ item.name }}
								<a class="l-parimay" style="margin-left: 10px" :href="item.download_url" target="_blank">下载</a>
							</div>
						</div>
					</td>
				</tr>
				<tr>
					<td colspan="3">
						<span class="l-info-label">备注：</span>
						<span class="l-info-content">{{ form_data.remark }}</span>
					</td>
				</tr>
				<template v-if="form_data.state == 2 || form_data.state == 3">
					<tr>
						<td>
							<span class="l-info-label">审批人：</span>
							<span class="l-info-content">{{ form_data.review_user_name }}</span>
						</td>
						<td>
							<span class="l-info-label">审批时间：</span>
							<span class="l-info-content">{{ form_data.review_time }}</span>
						</td>
						<td></td>
					</tr>
					<tr>
						<td colspan="3">
							<span class="l-info-label">审批备注：</span>
							<span class="l-info-content">{{ form_data.review_desc }}</span>
						</td>
					</tr>
				</template>
			</tbody>
		</table>

		<!--已选的资产-->
		<l-divider></l-divider>
		<div>
			<l-assets-common-table ref="assets_table" :data="selected_assets" row-key="id" :readonly="true"></l-assets-common-table>
		</div>

		<!--弹出审核信息-->
		<l-dialog :visible.sync="review_remark_visible" title="审批" width="500px">
			<l-approval-review-remark :id="approvalId" :state="review_state" @on-success="onReviewSucess" :visible.sync="review_remark_visible" />
		</l-dialog>

		<div class="l-dialog-footer">
			<!--查看信息时可见-->
			<el-button @click="cancel" v-show="!approvalId">关 闭</el-button>
			<!--审核时可见-->
			<template v-if="approvalId">
				<el-button type="danger" @click="showReviewRemark(3)">驳 回</el-button>
				<el-button type="primary" @click="showReviewRemark(2)">同 意</el-button>
			</template>
		</div>
	</div>
</template>

<script>
import { dateToStr } from "@/utils/Fuc";
import AssetsTable from "../assets/CommonTable";
import States from "../approval/States.vue";
import { getName } from "./types";
import ReviewRemark from "../approval/ReviewRemark";
export default {
	name: "l-assets-dispose-info",
	components: {
		[AssetsTable.name]: AssetsTable,
		[States.name]: States,
		[ReviewRemark.name]: ReviewRemark,
	},
	props: {
		id: {
			type: [Number, String],
			default: null,
		},
		visible: {
			type: Boolean,
		},

		//审批时会传order_no
		orderNo: {
			type: String,
			default: null,
		},
		approvalId: {
			type: [Number, String],
			default: null,
		},
	},
	computed: {
		hasId() {
			return this.$props.id !== null;
		},
	},
	data() {
		return {
			loading: false,

			show_select_assets: false,

			review_remark_visible: false, //是否弹出审核窗
			review_state: "",

			//表单数据
			submitting: false,

			del_selected_ids: [],

			selected_assets: [],
			file_list: [],
			form_data: {
				assets_ids: [],
				dispose_date: dateToStr(new Date(), "date"),
				type: "",
				money: "",
				files: [],
				remark: "",
			},
		};
	},

	watch: {
		visible: {
			immediate: true,
			handler(val) {
				if (val) {
					this.getData();
				}
			},
		},
	},

	methods: {
		//点击取消通知父组件关闭对话框
		cancel() {
			this.$emit("update:visible", false);
		},
		//获取添加数据
		getData() {
			//编辑获取数据
			this.loading = true;
			let params = { id: this.$props.id };
			if (this.$props.orderNo) {
				params = { order_no: this.$props.orderNo };
			}
			this.$_invoke("assetsDispose_getInfo", params)
				.then((ret) => {
					this.file_list = ret.file_list;
					this.form_data = ret.form_data;
					this.selected_assets = ret.selected_assets;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		//弹出审核描述
		showReviewRemark(state) {
			this.review_state = state;
			this.$nextTick(() => {
				this.review_remark_visible = true;
			});
		},

		//获取类型名称
		getTypeName(type) {
			return getName(type);
		},

		//审核提交成功
		onReviewSucess() {
			this.review_remark_visible = false;
			this.$emit("on-success");
		},
	},
};
</script>
